import React, { useState } from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';

const { Option, OptGroup } = Select;



const DoubleSelect = ({value, onChangeFunc}) => {
  
  const userState = useSelector(state => state.user);

  const handleChange = (value) => {
    onChangeFunc(value);
  };

  return (
    <div>
      <Select
        value={value}
        onChange={handleChange}
        placeholder="Select Sources"
        style={{ width: '100%' }}
        showSearch ={false}
        allowClear
    mode='multiple'
        optionFilterProp="children"
        optionLabelProp="label"
      filterOption={(input, option) =>
        option?.label.toLowerCase().includes(input.toLowerCase())
      } 
    maxTagCount={0}  // Hide the tags
    maxTagPlaceholder={`${value.length} Selected`} 

      >
        {Object.entries(userState.agenticSources===undefined?{}:userState.agenticSources).map(([groupLabel, items]) => (
          <OptGroup key={groupLabel} label={groupLabel}>
            {items.map((item) => (
              <Option key={item.value} value={item.value}>
                {item.label}
              </Option>
            ))}
          </OptGroup>
        ))}
      </Select>
    </div>
  );
};


export default DoubleSelect;
